export enum ETipoCuestionario {
  TEXTO = 1,
  EMAIL = 2,
  NUMERO = 3,
  OPCIONES = 4,
  FECHA = 5,
  CHECK = 6,
  TEXTO_LARGO = 7,
  TELEFONO = 8,
  RUT = 9,
}
